// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3HiYV","rootSuccess":"CompleteLink_rootSuccess__LSJnb","rootFailure":"CompleteLink_rootFailure__tY3Z3","isDisabled":"CompleteLink_isDisabled__3cvYK"};